import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getHeaders } from 'src/app/shared/utils/headers.functions';
import { EditWorkOrdersModel, WorkOrdersModel } from '../../work-orders/work-orders.models';

const BASE_URL: string = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class WorkOrdersService {
  constructor(
    private http: HttpClient
  ) { }

  public createWorkOrder(workOrder: WorkOrdersModel): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.post<any>(`${BASE_URL}/work-order`, workOrder, { headers });
  }
  public getWorkOrders(limit: number, offset: number, status: string): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/work-order?limit=${limit}&offset=${offset}&Status=${status}`, { headers });
  }

  public getWorkOrder(id: (number | string)): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/work-order/${id}`);
  }

  public updateWorkOrder(workOrder: EditWorkOrdersModel, id: number): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.put<any>(`${BASE_URL}/work-order/${id}`, workOrder, { headers });
  }

  public uploadImg(formData: any): Observable<any> {
    return this.http.post<any>(`${BASE_URL}/uploadimg`, formData, { });
  }
  
}
